import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Hero from "../components/Hero";
import Stats from "../components/Stats";
import ZonesSection from "../components/zones";
import ResumeApplicationModal from "../components/ResumeApplicationModal";
import CheckApplicationStatusModal from "../components/CheckApplicationStatusModal";
import authFetch from "../axios";
import abstractWhite from "../assets/npc/abstract-white.png";
import { handleChange } from "../redux/userSlice";
import { USER_TYPE } from "../utils";

const toTitleCase = (str) =>
  str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());

const mapZones = (apiZones) =>
  apiZones.map((z) => ({
    id: z.zone,
    name: z.zoneName,
    target: z.target,
    registered: z.registered,
    activeRegistrars: z.activeRegistrars,
    achievement: z.achievement,
  }));

const mapStates = (apiStates) =>
  apiStates.map((s) => ({
    id: s.stateId,
    name: toTitleCase(s.stateName),
    zone: s.zoneName,
    target: s.target,
    registered: s.registered,
    achievement: s.achievement,
    last30Days:
      s.last30DaysGrowth != null
        ? s.last30DaysGrowth >= 0
          ? `+${s.last30DaysGrowth.toLocaleString()}`
          : `${s.last30DaysGrowth.toLocaleString()}`
        : "N/A",
    registrars: s.activeRegistrars,
    facilitySplit:
      s.facilityPercentage != null && s.communityPercentage != null
        ? `${s.facilityPercentage}% / ${s.communityPercentage}%`
        : "N/A",
  }));

const Landing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [resumeShow, setResumeShow] = useState(false);
  const [checkStatusShow, setCheckStatusShow] = useState(false);

  useEffect(() => {
    authFetch
      .get("/dashboard-statistics")
      .then((res) => setDashboardData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleStartApplication = () => {
    dispatch(handleChange({ name: "usertype", value: USER_TYPE.ADHOC }));
    sessionStorage.setItem("user-type", USER_TYPE.ADHOC);
    sessionStorage.setItem("checkFirst", true);
    navigate("/instructions");
  };

  const zones = dashboardData ? mapZones(dashboardData.zones) : [];
  const states = dashboardData ? mapStates(dashboardData.states) : [];

  return (
    <div
      className="min-h-screen w-full flex flex-col"
      style={{ background: "#f6f6f6", fontFamily: "'Open Sans', sans-serif" }}
    >
      <Hero />
      <div
        className="mx-auto w-full px-4 md:px-6"
        style={{ maxWidth: "1440px" }}
      >
        {/* Recruitment card — overlaps hero */}
        <div
          className="relative z-10 mx-auto w-full flex items-center justify-center"
          style={{
            backgroundImage: `url('${abstractWhite}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            marginTop: "-64px",
            borderRadius: "12px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
            minHeight: "280px",
            padding: "40px 24px",
            maxWidth: "1309px",
          }}
        >
          <div
            className="flex flex-col items-center text-center w-full"
            style={{ gap: "47px" }}
          >
            <div flex className="flex flex-col items-center gap-1">
              <h2
                className="font-semibold mb-0 mt-0"
                style={{ fontSize: "clamp(20px, 3vw, 40px)", color: "#3E4A41" }}
              >
                Ward Registrars Management System
              </h2>
              <p
                className="mb-0 mt-0 text-sm md:text-lg"
                style={{ color: "#3E4A41" }}
              >
                National Infrastructure Dashboard & Secure Administrative Portal
              </p>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
              <button
                onClick={handleStartApplication}
                className="font-semibold tracking-widest"
                style={{
                  background: "#2D5336",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "20px 32px",
                  fontSize: "15px",
                  cursor: "pointer",
                  letterSpacing: "-0.009em",
                }}
              >
                START APPLICATION
              </button>
              <button
                onClick={() => setResumeShow(true)}
                className="font-semibold tracking-widest"
                style={{
                  background: "#D9A01B",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  padding: "20px 32px",
                  fontSize: "15px",
                  cursor: "pointer",
                  letterSpacing: "-0.009em",
                }}
              >
                RESUME APPLICATION
              </button>
              <button
                onClick={() => setCheckStatusShow(true)}
                className="font-semibold tracking-widest"
                style={{
                  background: "transparent",
                  color: "#2D5336",
                  border: "2px solid #2D5336",
                  borderRadius: "6px",
                  padding: "18px 32px",
                  fontSize: "15px",
                  cursor: "pointer",
                  letterSpacing: "-0.009em",
                }}
              >
                CHECK APPLICATION STATUS
              </button>
            </div>
          </div>
        </div>

        <Stats
          national={dashboardData?.national}
          lastUpdated={dashboardData?.lastUpdated}
          loading={loading}
        />
        <ZonesSection zones={zones} states={states} loading={loading} />
      </div>

      <ResumeApplicationModal
        show={resumeShow}
        onHide={() => setResumeShow(false)}
      />
      <CheckApplicationStatusModal
        show={checkStatusShow}
        onHide={() => setCheckStatusShow(false)}
      />
    </div>
  );
};

export default Landing;
